import { useBreakpointValue } from '@genial/utils';

import { FilterDesktop } from './Desktop';
import { FilterMobile } from './Mobile';

export const Filters = (props) => {
  const responsiveFilter = useBreakpointValue({
    base: <FilterMobile {...props} />,
    sm: <FilterDesktop {...props} />,
  });

  return responsiveFilter;
};
